import * as React from "react"
import { SVGProps, memo } from "react"

const Star = memo((props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 17"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.99986 1.1665C8.2536 1.1665 8.48535 1.31055 8.59766 1.53809L10.5027 5.39748L14.7629 6.02018C15.014 6.05687 15.2224 6.23288 15.3007 6.47422C15.3789 6.71555 15.3134 6.98039 15.1317 7.15741L12.0495 10.1594L12.7769 14.4005C12.8198 14.6506 12.717 14.9034 12.5117 15.0525C12.3064 15.2017 12.0342 15.2213 11.8096 15.1032L7.99986 13.0997L4.19016 15.1032C3.96555 15.2213 3.69335 15.2017 3.48803 15.0525C3.28272 14.9034 3.17989 14.6506 3.22278 14.4005L3.95018 10.1594L0.868035 7.15741C0.686289 6.98039 0.620774 6.71555 0.699026 6.47422C0.777278 6.23288 0.985731 6.05687 1.23677 6.02018L5.49702 5.39748L7.40205 1.53809C7.51437 1.31055 7.74611 1.1665 7.99986 1.1665ZM7.99986 3.33934L6.53766 6.30159C6.44064 6.49815 6.25318 6.63446 6.03628 6.66616L2.76546 7.14424L5.13168 9.44893C5.28893 9.60209 5.3607 9.82285 5.3236 10.0392L4.76531 13.2943L7.68956 11.7565C7.88381 11.6543 8.1159 11.6543 8.31016 11.7565L11.2344 13.2943L10.6761 10.0392C10.639 9.82285 10.7108 9.60209 10.868 9.44893L13.2342 7.14424L9.96344 6.66616C9.74654 6.63446 9.55908 6.49815 9.46205 6.30159L7.99986 3.33934Z"
            stroke="currentColor"
            fill="none"
        />
    </svg>
));

export default Star;
